<template>
  <div :class="isMobile ? 'pa-2' : 'pa-4'">
    <div class="video-wrapper">
      <img v-if="logo" v-lazy="logo" class="logo" />
    </div>

    <template v-if="!disabled">
      <h3 class="pa-2" v-if="room">Please wait for {{ waitingFor }}...</h3>
      <div v-else>
        <h3 class="pa-2" style="font-style: italic">
          Please join the room to view {{ waitingFor }}.
        </h3>
        <v-btn
          large
          class="primary animated"
          :class="{ bounceIn: joinNudge }"
          @click="$emit('join')"
        >
          <v-icon small class="mr-2">group</v-icon> Join Room
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'WaitingConnection',
  props: {
    room: {},
    disabled: Boolean,
  },
  data() {
    return {
      joinNudge: false,
    };
  },
  computed: {
    ...mapState('rooms', ['roomConfig']),
    ...mapGetters('rooms', ['isHost']),
    logo() {
      return this.getFilePath('img/apex-logo.svg');
    },
    waitingFor() {
      return this.isHost ? 'guests' : 'hosts';
    },
  },
  methods: {
    nudgeJoin() {
      if (this.room) return true;
      this.joinNudge = !this.joinNudge;
      setTimeout(this.nudgeJoin.bind(this), 3000);
    },
  },
  mounted() {
    this.nudgeJoin();
  },
};
</script>
